import { useState } from "react"
import { passSetBinaryBlock } from "../main2worker"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faXmark,
} from "@fortawesome/free-solid-svg-icons"
import EditField from "../panels/editfield"
import CheckBox from "../panels/checkbox"
import { useTranslation } from "../../i18n/useTranslation"

const BinaryFileDialog = (props:
  {
    displayDialog: boolean,
    displayClose: () => void,
    binaryBuffer: Uint8Array,
    onLoadSuccess?: () => void
  }) => {
  const { t } = useTranslation()
  const [runCode, setRunCode] = useState(false)
  const [runAddress, setRunAddress] = useState(() => {
    const savedRunAddress = localStorage.getItem("binaryRunAddress")
    return savedRunAddress ? savedRunAddress : "0300"
  })

  const handleSetRunAddress = (value: string) => {
    const newValue = value.toUpperCase()
    if (newValue.match(/^([A-F0-9]{0,4})$/)) {
      setRunAddress(newValue)
      localStorage.setItem("binaryRunAddress", newValue)
    } else {
      setRunAddress(runAddress)
    }
  }

  const handleCancel = () => {
    props.displayClose()
  }

  const handleLoadBinary = () => {
    props.displayClose()
    if (props.binaryBuffer.length > 0) {
      const addr = parseInt("0x" + runAddress)
      passSetBinaryBlock(addr, props.binaryBuffer, runCode)
      props.onLoadSuccess?.()
    }
  }

  if (!props.displayDialog) return (<></>)

  return (
    <div className="modal-overlay"
      tabIndex={0} // Make the div focusable
      onKeyDown={(event) => {
        if (event.key === "Escape") handleCancel()
      }}>
      <div className="floating-dialog flex-column"
        style={{ left: "15%", top: "25%" }}>
        <div className="flex-column">
          <div className="flex-row-space-between">
            <div className="dialog-title">{t("binaryFile.title")}</div>
            <button className="push-button"
              onClick={handleCancel}>
              <FontAwesomeIcon icon={faXmark} style={{ fontSize: "0.8em" }} />
            </button>
          </div>
          <div className="horiz-rule"></div>
        </div>
        <div className="flex-column" style={{ marginRight: "10px" }}>
          <EditField name={t("binaryFile.loadAtAddress")}
            initialFocus={true}
            value={runAddress}
            setValue={handleSetRunAddress}
            isHex={true}
            placeholder="0300"
            width="5em" />
        </div>
        <CheckBox name={t("binaryFile.runAfterLoading")}
          checked={runCode}
          setChecked={setRunCode} />
        <div className="flex-row-space-between">
          <div></div>
          <div className="flex-row">
            <button className="push-button text-button"
              onClick={handleLoadBinary}>
              <span className="centered-title">{t("messages.ok")}</span>
            </button>
            <button className="push-button text-button"
              onClick={handleCancel}>
              <span className="centered-title">{t("messages.cancel")}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BinaryFileDialog
